export default __webpack_public_path__ + "static/media/GalanoGrotesque-ExtraBold.99df61b8.woff";